/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import RacedayLive from './RacedayLive';

/**
 * <RacedayLive /> module exports
 */
export { RacedayLive as default };



// WEBPACK FOOTER //
// ./src/js/RacedayLive/index.js